import { routes } from "consts";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useToaster } from "utils";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { PaziaLoader } from "components/atoms";
import { QUERIES_KEYS } from "queries";
import { queryClient } from "main";
import { useSurvey } from "api/hooks/useSurvey";
import { SurveyForm, SurveyFormValues } from "pages/SurveyCreate/SurveyForm";
import { surveyApi } from "api/surveyApi";

export const SurveyEditPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();
  const { surveyId } = useParams();

  const { isLoading, survey } = useSurvey(surveyId);

  const onSubmit = async (data: SurveyFormValues) => {
    try {
      await surveyApi.update(Number(surveyId), data);
      navigate(routes.SURVEYS);
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.SURVEY(surveyId!) });
      showSuccess("Ankieta została zaktualizowana.");
    } catch (e) {
      console.error(e);
      showError("Nie udało się zaktualizować ankiety.");
    }
  };

  if (isLoading) return <PaziaLoader position="center" />;
  if (!survey) return null;
  const breadcrumbs = [{ title: "Ankiety", path: routes.SURVEYS }, { title: survey.name }];

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Edycja ankiety" />
      <SurveyForm onSubmit={onSubmit} survey={survey} />
    </PageMain>
  );
};
